<div class="modal-content overflow-hidden">
  <div class="row m-0 p-4" style="min-height: 300px">
    <!-- Text and Actions Column -->
    <div
      class="col-7 d-flex flex-column justify-content-center align-items-center text-center"
    >
      <h3 class="mb-4 text-light fw-bold lh-base">
        Is your drivers license current? <br />
        Fill out the form faster. <br />
        Scan your drivers license.
      </h3>

      <button
        class="btn modern-btn secondary-btn px-4 py-2 mt-2"
        (click)="closeModal()"
      >
        No, Thank You
      </button>

      @if (processing) {
        <div class="mt-4 text-center">
          <span class="processing text-primary me-2 fw-bold fs-5"
            >Processing</span
          >
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          ></div>
        </div>
      }
    </div>

    <!-- Image Animation Column -->
    <div class="col-5 d-flex justify-content-center align-items-center">
      <div class="driver-license-anim-container">
        <div class="driver-license-img"></div>
      </div>
    </div>
  </div>
</div>
